export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">漫迷视频</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选漫迷推荐视频，快速了解当下热门漫画资讯和新番速递
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-200 transition-colors">
            <div className="relative aspect-video bg-background-100 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20manga%20themed%20video%20thumbnail%20illustration%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20comic%20panel%20aesthetic%20with%20soft%20gradient%20background%2C%20anime%20manga%20style%20artwork%20suitable%20for%20content%20card%20cover%2C%20clean%20composition%2C%20modern%20flat%20design%20with%20gentle%20textures&width=700&height=400&seq=media-01&orientation=landscape"
                alt="日漫新番速递：本季必追TOP10"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                  <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-background-50/90 text-xs font-medium text-foreground-700">日漫</span>
              <span className="absolute bottom-3 right-3 text-xs text-background-50 bg-black/40 px-2 py-0.5 rounded-md"><i className="ri-eye-line mr-1"></i>12.8万</span>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-heading font-semibold text-foreground-950 line-clamp-2 mb-1">日漫新番速递：本季必追TOP10</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">带你快速浏览本季最受关注的日漫新番，从热血到治愈一网打尽。</p>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-200 transition-colors">
            <div className="relative aspect-video bg-background-100 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20manga%20illustration%20with%20romantic%20theme%20and%20cherry%20blossom%20motifs%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20anime%20shoujo%20aesthetic%2C%20dreamy%20watercolor%20style%2C%20clean%20composition%20for%20video%20thumbnail%20card%2C%20gentle%20and%20inviting%20atmosphere&width=700&height=400&seq=media-02&orientation=landscape"
                alt="韩漫推荐：高甜恋爱漫精选"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                  <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-background-50/90 text-xs font-medium text-foreground-700">韩漫</span>
              <span className="absolute bottom-3 right-3 text-xs text-background-50 bg-black/40 px-2 py-0.5 rounded-md"><i className="ri-eye-line mr-1"></i>9.6万</span>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-heading font-semibold text-foreground-950 line-clamp-2 mb-1">韩漫推荐：高甜恋爱漫精选</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">精选五部口碑爆棚的韩漫恋爱作品，每一部都甜到心坎里。</p>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-200 transition-colors">
            <div className="relative aspect-video bg-background-100 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20martial%20arts%20and%20fantasy%20elements%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20dynamic%20action%20composition%2C%20ink%20wash%20painting%20meets%20modern%20manga%20aesthetic%2C%20clean%20video%20card%20cover%20layout&width=700&height=400&seq=media-03&orientation=landscape"
                alt="国漫崛起：不可错过的国产佳作"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                  <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-background-50/90 text-xs font-medium text-foreground-700">国漫</span>
              <span className="absolute bottom-3 right-3 text-xs text-background-50 bg-black/40 px-2 py-0.5 rounded-md"><i className="ri-eye-line mr-1"></i>15.2万</span>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-heading font-semibold text-foreground-950 line-clamp-2 mb-1">国漫崛起：不可错过的国产佳作</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">近年来国漫质量持续攀升，这些作品堪称国产漫画新标杆。</p>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-200 transition-colors">
            <div className="relative aspect-video bg-background-100 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20manga%20collection%20illustration%20with%20completed%20series%20theme%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20cozy%20bookshelf%20vibe%20with%20comic%20volumes%2C%20clean%20flat%20design%2C%20inviting%20reading%20atmosphere%2C%20video%20thumbnail%20card%20layout&width=700&height=400&seq=media-04&orientation=landscape"
                alt="完结佳作盘点：一口气看到结局"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                  <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-background-50/90 text-xs font-medium text-foreground-700">完结</span>
              <span className="absolute bottom-3 right-3 text-xs text-background-50 bg-black/40 px-2 py-0.5 rounded-md"><i className="ri-eye-line mr-1"></i>8.3万</span>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-heading font-semibold text-foreground-950 line-clamp-2 mb-1">完结佳作盘点：一口气看到结局</h3>
              <p className="text-xs text-foreground-600 line-clamp-2">不想追连载等更新？这些已完结高分漫画让你一次看过瘾。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}